import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import {renderToString} from 'react-dom/server'
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
// api
import ApiKey from '../api/ApiKey';
import BaseApi from '../api/BaseApi';
// components
import JSSidebar from './JSSidebar';
import NavBar from '../element/NavBar';
import Footer from '../element/Footer';
// forms
import JSEditProfileForm from '../forms/JSEditProfileForm';
// helpers
import { logOutIfTokenExpired, resultInfo } from '../helpers';
import { GoogleAnalyticsService } from 'core/services/GoogleAnalyticsService';

const JSEditProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation('global');
  const userType = Cookies.get('user_type');
  const tokenKey = Cookies.get('tokenClient');
  const isCopy = useLocation().pathname.startsWith('/candidates/copyCV');
  const [loading, setLoading] = useState(true);
  const [faculties, setFaculties] = useState([]);
  const [directories, setDirectories] = useState({});
  const [profileBody, setProfileBody] = useState({});
  const [subscribeAlert, setSubscribeAlert] = useState(true);
  const { profile_image = '' } = profileBody;


    const renderSubscribeAlert =()=> (<div className='subscribeAlertBox justify-content-center'>
                      <label className='subscribeAlertLabel '>
                        <input
                          type='checkbox'
                          name='subscribeAlert'
                          checked={subscribeAlert}
                          className='me-2 subscribeAlertCheckbox'
                          onChange={() => setSubscribeAlert(prevState => !prevState)}
                        />
                        {t('jobDescription.subscribeAlert')}
                      </label>
                    </div>)


  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        id
          ? BaseApi + `/candidates/editCv/${id}`
          : BaseApi + '/candidates/editProfile',
        null,
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            'Content-Type': 'application/json',
          },
        },
      );

      setLoading(false);

      if (response.data.status === 200) {
        const data = response.data.response;
        const userDetail = data.userdetail;

        setDirectories(data);
        setProfileBody(userDetail);
      } else if (response.data.status === 400) {
        navigate('/');

        Cookies.remove('fname');
        Cookies.remove('user_id');
        Cookies.remove('user_type');
        Cookies.remove('tokenClient');

        resultInfo('warning', response.data.message, t('jobseekerEditProfile.close'));
      } else {
        resultInfo('error', response.data.message, t('jobseekerEditProfile.close'));
      }
    } catch (error) {
      setLoading(false);

      if (error.message === 'Network Error' || (error.response && error.response.data.message === 'Token has expired')) {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      } else if (error.response.status === 403) {
        Swal.fire({
          icon: 'warning',
          title: error.response.data.message,
          confirmButtonText: t('jobseekerManageAlert.close'),
        }).then(result => {
          if (result.isConfirmed) {
            navigate('/');
          }
        });
      }

      console.error(error);
    }
  };

  const handleSubmit = async values => {
    GoogleAnalyticsService.trackEvent('create-resume', {
      message: "Start create resume",
      status: "INFO"
    })
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: t('jobseekerEditProfile.no'),
        confirmButtonText: t('jobseekerEditProfile.yes'),
        title: t('jobseekerEditProfile.editConfirmTitle'),
      });

      if (confirmationResult.isConfirmed) {
        const response = await axios.post(
          id
            ? BaseApi + `/candidates/editCv/${id}`
            : BaseApi + '/candidates/editProfile',
          values,
          {
            headers: {
              key: ApiKey,
              token: tokenKey,
              'Content-Type': 'application/json',
            },
          },
        );

        setLoading(false);

        if (response.data.status === 200) {
          navigate('/candidates/my-cv-list');

          resultInfo('success', t('jobseekerEditProfile.editSuccessTitle'), t('jobseekerEditProfile.close'));
           GoogleAnalyticsService.trackEvent('create-resume', {
            
      message: t('jobseekerEditProfile.editSuccessTitle'),
      status: "SUCCESS"
    })
        } else if (response.data.status === 400) {
          navigate('/');

          Cookies.remove('fname');
          Cookies.remove('user_id');
          Cookies.remove('user_type');
          Cookies.remove('tokenClient');

          resultInfo('warning', response.data.message, t('jobseekerEditProfile.close'));
          GoogleAnalyticsService.trackEvent('create-resume', {
            
      message: response.data.message,
      status: "WARNING"
    })
        } else {
          resultInfo('error', response.data.message, t('jobseekerEditProfile.close'));
          GoogleAnalyticsService.trackEvent('create-resume', {
            
      message: response.data.message,
      status: "ERROR"
    })
        }
      }
    } catch (error) {
      setLoading(false);

      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      } else {
        resultInfo('error', t('jobseekerEditProfile.editFailedTitle'), t('jobseekerEditProfile.close'));
      }

      console.error('Could not submit edit data!', error);
    }
  };

  const handleCreate = async values => {
    GoogleAnalyticsService.trackEvent('create-resume', {
      status: "INFO",
      message: 'Start create resume'
    })
    try {
      const confirmationResult = await Swal.fire({
        icon: 'question',
        showCancelButton: true,
        html: renderToString(renderSubscribeAlert()),
        cancelButtonText: t('jobseekerEditProfile.no'),
        confirmButtonText: t('jobseekerEditProfile.yes'),
        title: t('jobseekerEditProfile.createConfirmTitle'),
      });
        GoogleAnalyticsService.trackEvent('create-resume', {
          status: "INFO",
          message: 'Dialog open'
        })

      if (confirmationResult.isConfirmed) {
       GoogleAnalyticsService.trackEvent('create-resume', {
          status: "INFO",
          message: 'Dialog confirmed'
        })
        await axios.post(
          BaseApi + '/candidates/editProfile',
          {...values, 'subscribeAlert': subscribeAlert},
          {
            headers: {
              key: ApiKey,
              token: tokenKey,
              'Content-Type': 'application/json',
            },
          },
        );

        const response = await axios.post(
          BaseApi + '/candidates/createCvFromProfile',
          null,
          {
            headers: {
              key: ApiKey,
              token: tokenKey,
              'Content-Type': 'application/json',
            },
          },
        );

        setLoading(false);

        if (response.data.status === 200) {
          navigate('/candidates/my-cv-list');
        GoogleAnalyticsService.trackEvent('create-resume', {
                status: "SUCCESS",
                message: t('jobseekerEditProfile.createSuccessTitle')
              })
          resultInfo('success', t('jobseekerEditProfile.createSuccessTitle'), t('jobseekerEditProfile.close'));
        } else if (response.data.status === 400) {
          navigate('/');
          GoogleAnalyticsService.trackEvent('create-resume', {
                status: "WARNING",
                message: response.data.message
              })
          Cookies.remove('fname');
          Cookies.remove('user_id');
          Cookies.remove('user_type');
          Cookies.remove('tokenClient');

          resultInfo('warning', response.data.message, t('jobseekerEditProfile.close'));
        } else {
          resultInfo('error', response.data.message, t('jobseekerEditProfile.close'));
            GoogleAnalyticsService.trackEvent('create-resume', {
                status: "ERROR",
                message: response.data.message
              })
        }
      }else {
              GoogleAnalyticsService.trackEvent('create-resume', {
      status: "INFO",
      message: 'Dialog close: not comfirmed'
    })
      }
  
    } catch (error) {
      setLoading(false);

      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');
        GoogleAnalyticsService.trackEvent('create-resume', {
                status: "ERROR",
                message: t('tokenExpired.tokenExpired')
              })
        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      } else {
            GoogleAnalyticsService.trackEvent('create-resume', {
                status: "ERROR",
                message: t('jobseekerEditProfile.createFailedTitle'),
              })
        resultInfo('error', t('jobseekerEditProfile.createFailedTitle'), t('jobseekerEditProfile.close'));
      }

      console.error('Could not submit edit data!', error);
    }
  };

  useEffect(() => {
    if (userType === 'recruiter' || !tokenKey) {
      navigate('/auth/candidate-login');
    } else {
      getData();
      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate, userType]); // eslint-disable-line

  return (
    <>
      <NavBar />
      <div className='container editProfile'>
        <div className='row'>
          <div className='col-lg-3'>
            <JSSidebar />
          </div>
          {
            loading
              ? (
                <div className='loader-container'></div>
              ) : (
                <div className='col-lg-9 mb-5'>
                  <div className='mx-lg-3 d-flex PageHeader'>
                    <img src='/Images/employerSide/icon8color.png' alt='' />
                    {
                      id
                        ? <h3>{t('jobseekerEditProfile.editCV')}</h3>
                        : <h3>{t('jobseekerEditProfile.createCV')}</h3>
                    }
                  </div>
                  <div className='JSEPFirstSegment'>
                    <div className='profileImageBox'>
                      <img
                        alt='profile image'
                        className='profileImage'
                        src={profile_image ? profile_image : '/Images/jobseekerSide/dummy-profile.png'}
                      />
                    </div>
                    <Link
                      to='/candidates/uploadPhoto'
                      className='btn btn-primary button1'
                    >
                      {t('jobseekerEditProfile.changePhotoButton')}
                    </Link>
                  </div>
                  {
                    profileBody != '' && (
                      <JSEditProfileForm
                        id={id}
                        isCopy={isCopy}
                        faculties={faculties}
                        directories={directories}
                        profileBody={profileBody}
                        handleCreate={handleCreate}
                        handleSubmit={handleSubmit}
                        setFaculties={setFaculties}
                      />
                    )
                  }
                </div>
              )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default JSEditProfile;
